import {
  AddBtn,
  Container,
  Header,
  ListContainer,
  SortContainer,
  SortText,
  Title
} from './style';
import { DropDown } from '../../../component/dropDown';
import { EmptyState, EmptyTxt } from '../../../component/emptyState';
import { useState } from 'react';
import { AddAdmin } from '../modals/addAdmin';
import { AdminCard } from './component/adminCard';
import { DeleteModal } from '../../../component/modal/deleteModal';
import {
  useDeleteAdminMutation,
  useFetchAdminQuery
} from '../../../store/admin/api';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { Loader } from '../../../component/loader';

export const AllAdmins = () => {
  const [sortByType, setSortByType] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [deleteAdminModal, setDeleteAdminModal] = useState(false);
  const [deleteAdmin, { isLoading: isDeletingAgent }] =
    useDeleteAdminMutation();
  const { data: admins, isLoading: isLoadingAdmins } = useFetchAdminQuery();
  const [adminId, setAdminId] = useState<string>('');

  const handleDeleteAgent = (itemId: string) => {
    setDeleteAdminModal(true);
    setAdminId(itemId);
  };
  const handleAdminDelete = () => {
    deleteAdmin(adminId)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setDeleteAdminModal(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };

  return (
    <Container>
      {isLoadingAdmins && <Loader />}
      {showAddModal && <AddAdmin setShow={setShowAddModal} />}
      {deleteAdminModal && (
        <DeleteModal
          deleteTitle="Delete admin"
          isLoading={isDeletingAgent}
          deleteText="Are you sure you want to delete this admin, this action can’t be undone?"
          deleteBtnClick={handleAdminDelete}
          cancelBtnClick={() => setDeleteAdminModal(false)}
        />
      )}
      <Header>
        <Title>All admins</Title>
        <AddBtn onClick={() => setShowAddModal(true)}>Add admin</AddBtn>
      </Header>
      <SortContainer>
        <SortText>Sort by</SortText>
        <DropDown
          value={sortByType}
          placeholder={'All admin'}
          onSelect={(item) => {
            setSortByType(item === 'All admin' ? '' : item);
          }}
          options={['All admin']}
        />
      </SortContainer>
      {admins?.data.fetchedData.length && !isLoadingAdmins ? (
        <ListContainer>
          {admins?.data.fetchedData.map((admin, index) => (
            <AdminCard
              key={admin._id}
              admin={admin}
              handleDelete={() => handleDeleteAgent(admin._id)}
            />
          ))}
        </ListContainer>
      ) : (
        <EmptyState>
          <EmptyTxt>
            No SOJI admins yet, click on the button below to add SOJI admins
          </EmptyTxt>
          <AddBtn onClick={() => setShowAddModal(true)}>Add admin</AddBtn>
        </EmptyState>
      )}
    </Container>
  );
};
